import { render, staticRenderFns } from "./PostCardSkeleton.vue?vue&type=template&id=36acaadd"
import script from "./PostCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PostCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports